import { useBreakpointValue } from "@chakra-ui/react";
import { useRecoilState, useRecoilValue } from "recoil";

import {
  addedProductsState,
  isDetailModalOpenedState,
  platformState,
  productDetailState
} from "src/states";
import { addCurrencyPrefix } from "src/utils";

const useShopItemHook = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  const [productDetail, setProductDetailState] = useRecoilState(productDetailState);
  const [isDetailModalOpened, setIsDetailModalOpened] = useRecoilState(isDetailModalOpenedState);
  const addedProducts = useRecoilValue(addedProductsState);
  const platform = useRecoilValue(platformState);

  const requiresPrescription = productDetail?.metadata?.requires_prescription ?? true;
  const fallbackPrice = addCurrencyPrefix(
    productDetail?.prices?.[0]?.metadata?.frequency_actual_price_display ?? ""
  );
  const isAdded = addedProducts.includes(productDetail?.id);

  return {
    isMobile,
    productDetail,
    setProductDetailState,
    setIsDetailModalOpened,
    isDetailModalOpened,
    requiresPrescription,
    fallbackPrice,
    isAdded,
    platform
  };
};

export default useShopItemHook;
